/**
 * @file faq.js
 *
 */

(function ($, Drupal, drupalSettings) {
  "use strict";

  Drupal.behaviors.resources = {
    attach: function (context, settings) {
      function liveSearch() {
        let search_query = $("#searchbox").val();

        cards.each(function () {
          if (
            $(this).text().toLowerCase().includes(search_query.toLowerCase())
          ) {
            $(this).removeClass("is-hidden");
          } else {
            $(this).addClass("is-hidden");
          }
        });
      }

      let cards = $(".faq__question-list , .video-resource");
      let typingTimer;
      let typeInterval = 500;
      let searchInput = $("#searchbox");

      searchInput.on("keyup", function () {
        clearTimeout(typingTimer);
        typingTimer = setTimeout(liveSearch, typeInterval);
      });

      // Expose the liveSearch function globally
      window.liveSearch = liveSearch;

      //$('.bef-exposed-form', context).clone().insertBefore('.view-header', context);
      // let memberType = $('.member-type', context);
      // memberType.insertBefore($('.view-header', context));
    },
  };

  Drupal.behaviors.showRelevantTerms = {
    attach: function (context, settings) {
      var list1 = $('[data-drupal-selector="edit-tid"] ul li', context);
      var list2_accounts = $(".form-item-accounts-tid-list-2", context);
      var list2_membership = $(".form-item-membership-tid-list-2", context);
      var list2_onlinebanking = $(
        ".form-item-onlinebanking-tid-list-2",
        context
      );

      // Retrieve the state from local storage or initialize it if not present
      var termState = JSON.parse(localStorage.getItem("relevantTermState")) || {
        accounts: false,
        membership: false,
        onlinebanking: false,
      };

      function updateTermState(parentText) {
        // Update the state of relevant terms
        termState.accounts = parentText === "Accounts";
        termState.membership = parentText === "Membership";
        termState.onlinebanking = parentText === "Online Banking";

        // Save the updated state in local storage
        localStorage.setItem("relevantTermState", JSON.stringify(termState));
      }

      function showHideTerms() {
        list2_accounts.toggleClass("show-term", termState.accounts);
        list2_membership.toggleClass("show-term", termState.membership);
        list2_onlinebanking.toggleClass("show-term", termState.onlinebanking);
      }

      list1.on("click", function (event) {
        event.preventDefault();
        // Get the clicked parent text
        var parentText = $(this).text().trim();

        updateTermState(parentText);
        showHideTerms();
      });

      // Check for active AJAX requests
      $(document).ajaxStart(function () {
        list2_accounts.removeClass("show-term");
        list2_membership.removeClass("show-term");
        list2_onlinebanking.removeClass("show-term");
      });

      // Restore the state of relevant terms after each AJAX request completes
      $(document).ajaxComplete(function () {
        showHideTerms();
      });
    },
  };
})(jQuery, Drupal, drupalSettings);
